import { Badge } from '@mantine/core';
import classNames from './badge.module.css';
export const badgeComponent = Badge.extend({
    classNames,
    styles: {
        label: {
            overflow: 'visible',
        },
    },
});
